/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Successful response
 * @export
 * @interface ValidateSession200Response
 */
export interface ValidateSession200Response {
    /**
     * 
     */
    status?: string;
}

/**
 * Check if a given object implements the ValidateSession200Response interface.
 */
export function instanceOfValidateSession200Response(value: object): value is ValidateSession200Response {
    return true;
}

export function ValidateSession200ResponseFromJSON(json: any): ValidateSession200Response {
    return ValidateSession200ResponseFromJSONTyped(json, false);
}

export function ValidateSession200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateSession200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function ValidateSession200ResponseToJSON(json: any): ValidateSession200Response {
    return ValidateSession200ResponseToJSONTyped(json, false);
}

export function ValidateSession200ResponseToJSONTyped(value?: ValidateSession200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
    };
}

